import React from 'react'
import {
    ButtonContainer,
    ButtonLinkContainer,
    LabelContainer,
    SmallLabelContainer
} from './styles'
import { tokens } from 'app-v2/design-systems/theme'
import type { AnchorButtonProps, ButtonProps } from './type'

export const Button = (props: ButtonProps) => {
    const {
        variant = 'contained',
        borderRadius = tokens.borderRadius,
        buttonColor,
        labelColor,
        onClick,
        small = false,
        children,
        otherStyle,
        fullLength = false,
        disabled,
        type,
        id,
        className,
        ...otherProps
    } = props

    return (
        <ButtonContainer
            type={type}
            variant={variant}
            color={buttonColor}
            borderRadius={borderRadius}
            onClick={onClick}
            small={small}
            fullLength={fullLength}
            disabled={disabled}
            id={id}
            className={className}>
            {small ? (
                <SmallLabelContainer
                    color={labelColor}
                    style={otherStyle}
                    {...otherProps}>
                    {children}
                </SmallLabelContainer>
            ) : (
                <LabelContainer
                    color={labelColor}
                    style={otherStyle}
                    {...otherProps}>
                    {children}
                </LabelContainer>
            )}
        </ButtonContainer>
    )
}

export const AnchorButton = (props: AnchorButtonProps) => {
    const {
        variant = 'contained',
        borderRadius = tokens.borderRadius,
        buttonColor,
        labelColor,
        onClick,
        small = false,
        children,
        otherStyle,
        fullLength = false,
        target,
        href
    } = props

    return (
        <ButtonLinkContainer
            href={href}
            target={target}
            variant={variant}
            color={buttonColor}
            borderRadius={borderRadius}
            onClick={onClick}
            small={small}
            fullLength={fullLength}>
            {small ? (
                <SmallLabelContainer color={labelColor} style={otherStyle}>
                    {children}
                </SmallLabelContainer>
            ) : (
                <LabelContainer color={labelColor} style={otherStyle}>
                    {children}
                </LabelContainer>
            )}
        </ButtonLinkContainer>
    )
}
